import { useRecoilCallback } from 'recoil'

import * as insightBuilderAtoms from 'src/atoms/insight-builder'

export const useResetInsightBuilder = () => {
  return useRecoilCallback(
    ({ reset }) =>
      () => {
        reset(insightBuilderAtoms.selectedCustomInsightId)
        reset(insightBuilderAtoms.selectedWidgetsData)
        reset(insightBuilderAtoms.insightTitle)
        reset(insightBuilderAtoms.insightIcon)
        reset(insightBuilderAtoms.isConfiguring)
      },
    []
  )
}
